<div
  class="demo-tile"
  [class]="cardStatus()"
  (mouseover)="cardHover = true"
  (mouseleave)="cardHover = false"
  [style]="{
    borderColor: cardStatus() === cardStatuses.news ? asset.newsCategoryColor : ''
  }"
>
  <div class="demo-tile-content">
    <div class="image-container">
      <brd-demo-tile-image [containerHover]="cardHover" [mediaModel$]="mediaObs$"></brd-demo-tile-image>
      <div class="expand-container" (click)="infoButtonClick($event, true)">
        <mat-icon svgIcon="maximize-16"></mat-icon>
      </div>
    </div>
    <div class="info-container">
      <div class="title-container">
        <div class="title" [matTooltip]="asset.name">
          {{ asset.name }}
        </div>
      </div>
      <div class="description">{{ asset.description }}</div>
    </div>
  </div>
  <div class="demo-tile-button">
    <brd-button
      *ngIf="!instancesQuotaExceeded && showButton()"
      class="add-button"
      [iconName]="cardStatus() === cardStatuses.added ? 'minus-16' : 'plus-16'"
      [text]="cardStatus() === cardStatuses.added ? 'remove' : 'add to collection'"
      [color]="cardHover && cardStatus() !== cardStatuses.added ? 'primary' : 'secondary'"
      [disabled]="cardStatus() === cardStatuses.disabeld"
      (clickEvent)="buttonClick($event)"
    ></brd-button>
    <brd-button
      iconName="info-16"
      text="info"
      color="no-border"
      class="info-button"
      [disabled]="cardStatus() === cardStatuses.disabeld"
      (clickEvent)="infoButtonClick($event)"
    ></brd-button>
  </div>
  <div class="suggested-badge" *ngIf="cardStatus() === cardStatuses.suggested">Suggested</div>
  <div class="disabled-badge" *ngIf="cardStatus() === cardStatuses.disabeld">Insufficient capacity</div>
  <div class="default-badge" *ngIf="cardStatus() === cardStatuses.markAsDefault">Default</div>
  <div
    class="news-badge"
    *ngIf="cardStatus() === cardStatuses.news"
    [style]="{
      background: asset.newsCategoryColor,
      borderColor: asset.newsCategoryColor
    }"
  >
    {{ asset.newsCategoryName }}
  </div>
</div>
